export default __webpack_public_path__ + "static/media/1st edition bookcover.73f007a7.png";